import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    accordion: {
      text: 'A beneficial owner holds more than 25% of voting rights or capital or has control over the company.',
      title: 'What is a beneficial owner?',
    },
    buttons: {
      cta: 'Start my declaration',
      skip: 'Declare later',
    },
    description: `We are legally required to collect information on all beneficial owners of {companyName}.`,
    heading: 'Declare beneficial owners',
    steps: [
      {
        description: 'We can help you find out who should appear on this list.',
        title: 'List all your beneficial owners',
      },
      {
        title: 'Complete their information',
      },
      {
        description: 'We will contact them to verify their identities.',
        title: 'Provide their emails',
      },
    ],
  },
  fr: {
    accordion: {
      text: "Un bénéficiaire effectif détient plus de 25 % des droits de vote ou du capital, ou dispose d'un pouvoir de contrôle sur l'entreprise.",
      title: 'Qu’est ce qu’un bénéficiaire effectif ?',
    },
    buttons: {
      cta: 'Démarrer ma déclaration',
      skip: 'Déclarer plus tard',
    },
    description: `Nous devons légalement recueillir les informations de tous les bénéficiaires effectifs de {companyName}.`,
    heading: 'Déclarez les bénéficiaires effectifs',
    steps: [
      {
        description:
          'Nous pouvons vous aider à savoir qui doit apparaître dans cette liste.',
        title: `Listez l'ensemble de vos bénéficiaires effectifs`,
      },
      {
        title: 'Complétez leurs informations',
      },
      {
        description: 'Nous les contacterons pour vérifier leur identité.',
        title: 'Renseignez leurs e-mails',
      },
    ],
  },
} as const);
